import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Pagination,Row,Col,Button} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {viewFlatFile} from '../../Utilities/WSUtil';
import {FILE_NAME, JSONFILE} from '../../resources/constant';
import {ContentDiv, BodyHeaderDiv, BodyHeaderText} from '../../theme/MorsTheme';
import {SubmitBtn} from '../../theme/MorsTheme';

const propTypes = {
    items: PropTypes.array.isRequired,
    onChangePage: PropTypes.func.isRequired,
    initialPage: PropTypes.number,
    pageSize: PropTypes.number
}

const defaultProps = {
    initialPage: 1,    
    pageSize: 5
}

class ReportFileTransactionList extends Component{            
    constructor(props){
        super(props);                  
        this.state = {
            pager: {},
            pageOfItems: []
        };  
        this.viewReport = this.viewReport.bind(this);
        this.onChangePage = this.onChangePage.bind(this);   
        this.viewInTabular = this.viewInTabular.bind(this);         
    }

    //async viewReport(fileName, path){        
    async viewReport(fileName, path, mbId, folderName, reportType){        
       
        await viewFlatFile(reportType, mbId, folderName, fileName, path).then(response => {
            var fileResponse = [{fileName}, {response}];
            localStorage.setItem(FILE_NAME, fileName);
            localStorage.setItem(fileName, JSON.stringify(fileResponse));
            //localStorage.setItem(FILE_NAME, JSON.stringify(fileResponse));
        })

        window.open('/mors/#/viewReportFile','_blank', 'rel=noopener noreferrer')
    }


    viewInTabular(file, path){              
       localStorage.setItem(JSONFILE, JSON.stringify({file, path}));
       window.open('/mors/#/viewTabularFile','_blank', 'rel=noopener noreferrer')        
    }



    onChangePage(pageOfItems){        
        this.setState({pageOfItems: pageOfItems});
    }

    componentWillMount(){        

        if(this.props.items && this.props.items.length){            
            this.setPage(this.props.initialPage);
        }
    }
    componentDidUpdate(prevProps, prevState){     
        if(this.props.items !== prevProps.items){         
            this.setPage(this.props.initialPage);
        }
    }
    setPage(page){
        var {items, pageSize} = this.props;
        var pager = this.state.pager;
        if(page<1 || page > pager.totalPages){
            return;
        }        
        pager = this.getPager(items.length, page, pageSize);
        var pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);
        this.setState({pager: pager});        
        this.onChangePage(pageOfItems);        
    }

    getPager(totalItems, currentPage, pageSize){                               
        currentPage = currentPage || 1;
        pageSize = pageSize || 5;        
        var totalPages = Math.ceil(totalItems/pageSize);        
        var startPage, endPage;        
        if(totalPages <=10){
            startPage = 1;
            endPage = totalPages;
        }
        
        else{
            if(currentPage <=4){
                startPage = 1;
                endPage = 5;
            }else if(currentPage + 4 >= totalPages){
                startPage = totalPages - 4;
                endPage = totalPages;
            }else{
                startPage = currentPage - 5;
                endPage = currentPage + 4;                
            }
        }

        var startIndex = (currentPage - 1 ) * pageSize;
        var endIndex = Math.min(startIndex + pageSize -1, totalItems -1);
        var pages = [...Array((endPage +1) - startPage).keys()].map(i=> startPage +i);

        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages:pages
        };    
    }

    goBack = e => {
        e.preventDefault();

        this.props.history.goBack();
    }
                     
    render(){        
        var pager = this.state.pager;
        return(
            <div>                            
                <BodyHeaderDiv>
                    <BodyHeaderText>List of Reports</BodyHeaderText>
                </BodyHeaderDiv>
                <ContentDiv style={{fontSize:'12px'}}>                    
                    <Row as={Row} noGutters style={this.props.items.length !== 0 ? {display:'block'}: {display:'none'}}>    
                        <Row noGutters >
                            <Col xs={2} md={2}>Date</Col>
                            <Col xs={2} md={2}>MID</Col>
                            <Col xs={4} md={4}>Filename</Col>
                            <Col xs={2} md={2}></Col>
                            <Col xs={2} md={2}></Col>
                        </Row>
                        {this.state.pageOfItems.map((item, index) =>                                                             
                            <Row style={{wordBreak: 'break-all',fontSize:'12px',}}  noGutters key={index} xs={12} md={12}>   
                                <Col xs={2} md={2} style={{padding:'1px'}}><span>{item.folderName}</span></Col>
                                <Col xs={2} md={2} style={{padding:'1px'}}><span>{item.mbId}</span></Col>
                                <Col xs={4} md={4} style={{padding:'1px'}}>
                                    <span>{item.fileName}</span>                                              
                                </Col>
                                <Col xs={2} md={2} style={{padding:'1px'}}>

                                    {/*
                                    <Link onClick={() => this.viewInTabular(item.fileName, item.absolutePath)}  to="/viewTabularFile" target="_blank"> <span>View Tabular Format</span></Link>
                                    */}

                                     
                                    <Button variant="text" style={{padding: '0px'}}
                                        onClick={() => this.viewInTabular(item.fileName, item.absolutePath)}> <span style={{fontSize:'12px', color: '#007BFF'}}>View Tabular Format</span>
                                    </Button>
                                            
                                </Col>
                                <Col xs={2} md={2} style={{padding:'1px'}}>
                                    {/*
                                    <Link onClick={() => this.viewReport(item.fileName, item.absolutePath)}  to="/viewReportFile" target="_blank"> <span>View Text Format</span></Link>
                                    */}
                                       
                                    <Button variant="text" style={{padding: '0px'}}
                                        onClick={() => this.viewReport(item.fileName, item.absolutePath, item.mbId, item.folderName, item.reportType)}> <span style={{fontSize:'12px', color: '#007BFF'}}>View Text Format</span>
                                    </Button>
                                    
                                </Col>  
                                {/* <Col xs={8} md={8}>    
                                        <Row as={Row}>
                                            <Col xs={4}>
                                            <span>{item.fileName}</span>                                            
                                            </Col>

                                            <Col xs={2}>
                                                <Link onClick={() => this.viewInTabular(item.fileName, item.absolutePath)}  to="/viewTabularFile" target="_blank"> <span>View Tabular Format</span></Link>
                                            </Col>
                                            <Col xs={2}>
                                            <Link onClick={() => this.viewReport(item.fileName, item.absolutePath)}  to="/viewReportFile" target="_blank"> <span>View Text Format</span></Link>
                                            </Col>                                            
                                        </Row>                            
                                   
                                </Col> */}
                            </Row>
                            )}                                            
                        
                    </Row>                                       
                    <div align="center" style={this.props.items.length !== 0 ? {display:'block', marginTop: '20px'}: {display:'none'}}>                            
                        <Pagination style={{display: 'flex', justifyContent:'center'}}>
                            <Pagination.First onClick={() => this.setPage(1)} />                                                                        
                            <Pagination.Prev onClick={() => this.setPage(pager.currentPage - 1)}/>                                                                        
                            <Pagination.Next onClick={() => this.setPage(pager.currentPage + 1)}/>
                            <Pagination.Last onClick ={() => this.setPage(pager.totalPages)}/>                     
                        </Pagination>                                             
                        
                        <div align="center">
                            <span>Page {pager.currentPage}</span> / {" "}                            
                            <span>{pager.totalPages}</span>
                        </div>  
                    </div>

                    <Row>
                        <Col>
                        <div style={this.props.items.length === 0 ? {display:'block'}: {display:'none'}}>
                            <span style={{color:'red'}}>Sorry, there is/are no recorded transaction/s for the date you selected.</span>                                                                                   
                        </div>
                        </Col>
                    </Row>
                    <Row style={{ marginTop:'20px'}}>
                        <Col>
                        <SubmitBtn style={{color:'#FFFFFF'}} onClick= {this.goBack}>Back</SubmitBtn>
                        </Col>

                    </Row>
                
            </ContentDiv>
        </div>                                  
    )
        
    }
    
}

ReportFileTransactionList.propTypes = propTypes;
ReportFileTransactionList.defaultProps = defaultProps;
export default ReportFileTransactionList;
